import React from 'react';
import './Spinner.css';
import { Popover, PopoverContent } from 'src/components/ui/popover';
import { clsx } from 'clsx';

interface SpinnerProps {
  fullScreen?: boolean;
  className?: string;
}

export const Spinner = ({ fullScreen = false, className = '' }: SpinnerProps) => {
  return fullScreen ? (
    <Popover modal open>
      <PopoverContent className={clsx('fixed bg-transparent border-none z-[1000]', className)}>
        <div className="spinner-wrapper w-screen h-screen">
          <div className={'spinner'}></div>
        </div>
      </PopoverContent>
    </Popover>
  ) : (
    <div className={clsx('spinner', className)}></div>
  );
};
